import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { HelpCircle, Scale } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es difícil de entender?',
    a: 'No. Está hecho para padres sin conocimientos técnicos.'
  }, {
    q: '¿Sirve para cualquier edad?',
    a: 'Sí, especialmente de 8 a 16 años.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Por email, en formato PDF.'
  }, {
    q: '¿Es aplicable en Argentina?',
    a: 'Sí, está adaptado a la realidad actual.'
  }];
  return <>
      <SectionWrapper data-id="element-12">
        <div className="text-center mb-8 md:mb-12" data-id="element-13">
          <div className="inline-flex items-center justify-center bg-sky-400/10 border border-sky-400/20 p-3 md:p-4 rounded-full mb-4 md:mb-6" data-id="element-14">
            <HelpCircle className="w-6 h-6 md:w-8 md:h-8 text-sky-400" data-id="element-15" />
          </div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-white" data-id="element-16">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4" data-id="element-17">
          {faqs.map((faq, i) => <div key={i} className="bg-[#0d3354] shadow-lg rounded-xl md:rounded-2xl p-5 md:p-8 border border-sky-900/40" data-id="element-18">
              <h4 className="text-base md:text-xl font-bold text-white mb-2 md:mb-3" data-id="element-19">
                {faq.q}
              </h4>
              <p className="text-sm md:text-lg text-slate-300" data-id="element-20">{faq.a}</p>
            </div>)}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-[#0a2c47] border-y border-sky-900/40" data-id="element-21">
        <div className="max-w-3xl mx-auto" data-id="element-22">
          <div className="text-center mb-8 md:mb-12" data-id="element-23">
            <Scale className="w-10 h-10 md:w-12 md:h-12 text-slate-500 mx-auto mb-4 md:mb-6" data-id="element-24" />
            <h2 className="text-2xl md:text-4xl font-extrabold text-white" data-id="element-25">
              ¿CUÁNTO CUESTA NO HACER NADA?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-26">
            <div className="bg-[#0d3354] shadow-lg rounded-xl md:rounded-2xl p-5 md:p-8 border border-sky-900/40" data-id="element-27">
              <h4 className="text-lg md:text-xl font-bold text-white mb-4 md:mb-6" data-id="element-28">
                Sin este sistema:
              </h4>
              <ul className="space-y-3 md:space-y-4 mb-5 md:mb-8" data-id="element-29">
                {['Seguís sin saber qué pasa en el celular', 'Reaccionás tarde', 'No tenés herramientas', 'Dependés de la suerte'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3 text-sm md:text-base text-slate-300" data-id="element-30">
                    <span className="text-red-500 font-bold" data-id="element-31">❌</span> {item}
                  </li>)}
              </ul>
              <p className="text-base md:text-xl font-bold text-red-500" data-id="element-32">
                👉 Y el riesgo sigue ahí.
              </p>
            </div>

            <div className="bg-sky-400/5 border border-sky-400/20 rounded-xl md:rounded-2xl p-5 md:p-8" data-id="element-33">
              <h4 className="text-lg md:text-xl font-bold text-sky-400 mb-4 md:mb-6" data-id="element-34">
                💡 EL CAMBIO
              </h4>
              <p className="text-sm md:text-base text-slate-300 mb-4 md:mb-6" data-id="element-35">
                No se trata de controlar todo.
                <br data-id="element-36" />
                Se trata de:
              </p>
              <div className="space-y-3 md:space-y-4" data-id="element-37">
                <p className="text-base md:text-xl font-bold text-white flex items-center gap-2" data-id="element-38">
                  <span className="text-sky-400" data-id="element-39">👉</span> entender
                </p>
                <p className="text-base md:text-xl font-bold text-white flex items-center gap-2" data-id="element-40">
                  <span className="text-sky-400" data-id="element-41">👉</span> acompañar
                </p>
                <p className="text-base md:text-xl font-bold text-white flex items-center gap-2" data-id="element-42">
                  <span className="text-sky-400" data-id="element-43">👉</span> proteger
                </p>
              </div>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </>;
}